/**
 * DISCLAIMER: This is written as a React hook but it doesn't currently make user of any React hooks or lifecycle
 * methods. The reason we write this as a hook is that we will ultimately move this logic out of angular services and
 * either into this file or some other service, but we will need access to the user data to be able to check features.
 * This data will likely be stored in some store (context/redux) and we will need other hooks in here. So the structure
 * of this file is to future proof for when we have enough pieces in place to write this as a real hook.
 *
 * If you are writing a similar angular bridging hook that doesn't have any internal state or use other react hooks,
 * please copy this disclaimer to your new hook.
 */

import { getAngularService } from '@hotjar/webapp/utils/angular-injector';

type Location = 'central' | 'corner';
type When = 'immediately' | 'onReload';

interface Options {
  when?: When;
  location?: Location;
  timeout?: number;
}

type CustomizedNotify = (message: string) => void;

interface NotifyFunctions {
  success: CustomizedNotify;
}

/**
 * Provides a set of functions that display Notify messages of different types.
 *
 * Usage:
 * const { success } = useNotify({ when: 'onReload', location: 'corner'});
 * success('This is the message);
 */

export function useNotify(options: Options = {}): NotifyFunctions {
  const ngNotifyService = getAngularService('Notify');

  return {
    success: (message: string): void => ngNotifyService.success(message, options),
  };
}
